// 针对试用baseContain组件布局的页面： 动态计算表格高度 
export default {
  data() {
    return {
        maxTbHeight: 100,
    }
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.setTableHeight);
  },

  mounted() { 
      setTimeout(() => {
        this.setTableHeight();
      }, 100)
      window.addEventListener('resize', this.setTableHeight);
  },

  methods: {
    // 计算表格最大高度
    setTableHeight(extraHeight) {
      let viewBdH = document.querySelector("#app .base-container").clientHeight;
      let toolH = document.querySelector("#app .base-container .base-container-bd .content-hd").clientHeight;
      let theadH = document.querySelector("#app .base-container .base-container-bd .el-table__header-wrapper").clientHeight;
      this.maxTbHeight = viewBdH - toolH  - 49 - 35;   // 49: 分页高度， 30: 各种padding和margin
      console.log('this.maxTbHeight==', this.maxTbHeight)
    },
  }

}


// WEBPACK FOOTER //
// ./src/mixins/fitTableHeight.js